var exports = {
  "no": "OkeyBoard.module__board___TzBTVX",
  "Nu": "OkeyBoard.module__opponents___TzBTVX",
  "am": "OkeyBoard.module__seat___TzBTVX",
  "Gn": "OkeyBoard.module__seatHead___TzBTVX",
  "yU": "OkeyBoard.module__seatBody___TzBTVX",
  "Fd": "OkeyBoard.module__seatName___TzBTVX",
  "U9": "OkeyBoard.module__count___TzBTVX",
  "nl": "OkeyBoard.module__deadline___TzBTVX",
  "hN": "OkeyBoard.module__ring___TzBTVX",
  "YQ": "OkeyBoard.module__ringTrack___TzBTVX",
  "YA": "OkeyBoard.module__ringFill___TzBTVX",
  "Ij": "OkeyBoard.module__seconds___TzBTVX",
  "gX": "OkeyBoard.module__center___TzBTVX",
  "q3": "OkeyBoard.module__indicator___TzBTVX",
  "W5": "OkeyBoard.module__centerLabel___TzBTVX",
  "Bc": "OkeyBoard.module__pile___TzBTVX",
  "o1": "OkeyBoard.module__actions___TzBTVX",
  "Zc": "OkeyBoard.module__withTile___TzBTVX",
  "aK": "OkeyBoard.module__hint___TzBTVX",
  "z3": "OkeyBoard.module__error___TzBTVX",
};

module.exports = exports;
